'use strict';

import AssignmentWorkQuestion from '../../model/domain/assignment-work-question';
import TotalGradeDisplayTemplate from './total-grade.html';

export default function TotalGradeDisplay() {
  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      potentialScore: '=',
      readonly: '=',
    },
    template: TotalGradeDisplayTemplate,
    link: TotalGradeDisplayController.link,
    controller: TotalGradeDisplayController,
    controllerAs: 'ctrl',
  };
}

export class TotalGradeDisplayController {
  constructor($q, $timeout, hotkeys) {
    'ngInject';

    this.$q = $q;
    this.$timeout = $timeout;

    this._loading = true;
    this._gradeInput = undefined;
    this._hiddenSpan = undefined;
    this._grade = undefined;
  }

  static get MAX_GRADE() {
    return 100;
  }

  get TOTAL_GRADE_SELECTOR() {
    return '.total-grade';
  }

  get HIDDEN_SPAN_SELECTOR() {
    return '.hidden-grade-span';
  }

  static link(scope, element, attrs, ngModel) {
    /** @type {TotalGradeDisplayController} */
    const ctrl = scope.ctrl;
    ctrl.ngModel = ngModel;
    ctrl._gradeInput = element.find(ctrl.TOTAL_GRADE_SELECTOR);
    ctrl._hiddenSpan = element.find(ctrl.HIDDEN_SPAN_SELECTOR);

    scope.$watch('potentialScore', (value) => {
      if (angular.isNumber(value)) {
        ctrl.potentialScore = value;
      }
    });
  }

  get potentialScore() {
    return this._potentialScore;
  }

  set potentialScore(value) {
    this._potentialScore = value;
  }

  // removing potential score for ISTE
  get potentialScoreDisplay() {
    return ''; //this.hasPotentialScore ? `/ ${this.potentialScore}` : '';
  }

  get hasPotentialScore() {
    return angular.isNumber(this.potentialScore);
  }

  get placeholder() {
    return this.hasPotentialScore ? '--' : 0;
  }

  get readonly() {
    return true;
  }

  /**
   * @param value {NgModelController}
   */
  set ngModel(value) {
    this._ngModel = value;
    this._ngModel.$render = () => this._init();
  }

  _init() {
    if (angular.isNumber(this.ngModelValue)) {
      this._grade = this.ngModelValue.toString();
      this._setWidthFromNgModel();
      this._loading = false;
    } else {
      this._grade = this.ngModelValue;
      this._setWidthFromNgModel();
      this._loading = false;
    }
  }

  /**
   * @returns {number|string}
   */
  get ngModelValue() {
    return this._ngModel.$viewValue;
  }

  /**
   * @returns {HTMLElement}
   */
  get hiddenSpan() {
    return this._hiddenSpan;
  }

  /**
   * @returns {HTMLElement}
   */
  get gradeInput() {
    return this._gradeInput;
  }

  /**
   * @returns {string}
   */
  get grade() {
    return this._grade;
  }

  /**
   * @returns {string|undefined}
   */
  get tooltipMessage() {
    return 'Your total score';
  }

  /** Helper methods to resize input element **/

  /**
   * Sets input width based on value of NgModel
   */
  _setWidthFromNgModel() {
    this._setInputWidth(this.gradeInput, this.grade.toString());
  }

  /**
   * Sets input width based on value in HTMLInputElement
   * @private
   */
  _setWidthFromHTMLInputElement() {
    this._setInputWidth(this.gradeInput, this.gradeInput.val());
  }

  /**
   * @param input {HTMLElement}
   * @param points {string}
   */
  _setInputWidth(input, points) {
    if (points) {
      this.hiddenSpan.text(points);
      this.$timeout(() => {}, 100, false).then(() => {
        this._setInputToSpanWidth(input);
      });
    }
  }

  _setInputToSpanWidth(input) {
    let newInputWidth = this.hiddenSpan.width() + 5;
    input.width(newInputWidth);
  }
}
